// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const app = angular.module('landingPage');

app.directive('giParallaxScroller', ($document) => ({
  link(scope, elem, attr) {
    const speed = 0.1;
    const backgroundHeight = 500;
    const offset = 100;

    const { top } = $(elem).offset();
    const wh = window.innerHeight;
    const image = $(elem).data().src;
    $(elem).find('.p1').css('background-image', `url(${image})`);
    const position = function () {
      const y = window.pageYOffset - top + (wh - backgroundHeight) / 2;
      return $(elem).css({ backgroundPosition: `50% ${y * speed - offset}px` });
    };

    position();

    return $document.on('scroll', function () {
      position();
      return true;
    });
  },
}));
